// extracted by mini-css-extract-plugin
module.exports = {"bubbleContainer":"ChatBubble_bubbleContainer__ylVX5","narvarUser":"ChatBubble_narvarUser__qPobg","chatBubble":"ChatBubble_chatBubble__o_sL1"};